import React, { Component } from 'react';
import { Modal } from "react-bootstrap";

class ModalEvents extends Component {
    state = {
        show: this.props.isopen
    }

    componentWillReceiveProps (props) {
        this.setState({
            show: props.isopen
        });
    }

    cerrarModal = () => (e) => {
        this.props.cerrar();
        this.setState({ show: false });
    }

    render() {
        let { contenido } = this.props;
        return (
            <Modal bsSize ="large" backdrop ="static" show = {this.state.show} className="modal-event-top" onHide = {this.cerrarModal()}>
                <Modal.Header 
                    closeButton = {true}>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img src ={contenido} className="img img-responsive"/>
                </Modal.Body>
            </Modal>
        );
    }
}
 
export default ModalEvents;


// WEBPACK FOOTER //
// ./src/site/Componentes/Eventos/ModalEvents.jsx